"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vaultAddress = exports.voterAddress = exports.voterWeightRecordAddress = exports.registrarAddress = exports.lockupKind = exports.LockupKindEnum = exports.getVsrProgram = exports.VoterStakeRegistryIDL = exports.MNDE_MINT = exports.MNDE_VSR_REGISTRAR_ADDRESS = exports.MNDE_VSR_PROGRAM_ID = exports.MNDE_REALM_ADDRESS = void 0;
const web3_js_1 = require("@solana/web3.js");
const generated = __importStar(require("./VsrClientIdl"));
const utf8_1 = require("@coral-xyz/anchor/dist/cjs/utils/bytes/utf8");
const anchor_1 = require("@coral-xyz/anchor");
const solana_spl_token_modern_1 = require("solana-spl-token-modern");
const nodewallet_1 = __importDefault(require("@coral-xyz/anchor/dist/cjs/nodewallet"));
exports.MNDE_REALM_ADDRESS = new web3_js_1.PublicKey('899YG3yk4F66ZgbNWLHriZHTXSKk9e1kvsKEquW7L6Mo');
exports.MNDE_VSR_PROGRAM_ID = new web3_js_1.PublicKey('VoteMBhDCqGLRgYpp9o7DGyq81KNmwjXQRAHStjtJsS');
exports.MNDE_VSR_REGISTRAR_ADDRESS = new web3_js_1.PublicKey('5zgEgPbWKsAAnLPjSM56ZsbLPfVM6nUzh3u45tCnm97D');
exports.MNDE_MINT = new web3_js_1.PublicKey('MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey');
exports.VoterStakeRegistryIDL = generated.IDL;
function getVsrProgram({ connection, provider, wallet, opts, programId = exports.MNDE_VSR_PROGRAM_ID, }) {
    if (!provider && connection) {
        if (!wallet) {
            throw new Error('wallet is required when provider is not specified to get VoterStakeRegistry program');
        }
        if (wallet instanceof web3_js_1.Keypair) {
            wallet = new nodewallet_1.default(wallet);
        }
        provider = new anchor_1.AnchorProvider(connection, wallet, opts || { commitment: connection.commitment });
    }
    if (!provider) {
        throw new Error('provider or connection is required to get VoterStakeRegistry program');
    }
    return new anchor_1.Program(exports.VoterStakeRegistryIDL, programId, provider);
}
exports.getVsrProgram = getVsrProgram;
var LockupKindEnum;
(function (LockupKindEnum) {
    LockupKindEnum["None"] = "none";
    LockupKindEnum["Daily"] = "daily";
    LockupKindEnum["Monthly"] = "monthly";
    LockupKindEnum["Cliff"] = "cliff";
    LockupKindEnum["Constant"] = "constant";
})(LockupKindEnum || (exports.LockupKindEnum = LockupKindEnum = {}));
function lockupKind(lockupKind) {
    if (typeof lockupKind !== 'object' || Object.keys(lockupKind).length !== 1) {
        throw new Error('Cannot decode lockup kind: ' + lockupKind);
    }
    switch (Object.keys(lockupKind)[0]) {
        case 'none':
            return LockupKindEnum.None;
        case 'daily':
            return LockupKindEnum.Daily;
        case 'monthly':
            return LockupKindEnum.Monthly;
        case 'cliff':
            return LockupKindEnum.Cliff;
        case 'constant':
            return LockupKindEnum.Constant;
        default:
            throw new Error('Cannot decode lockup kind: ' + lockupKind);
    }
}
exports.lockupKind = lockupKind;
// [realm.key().as_ref(), b"registrar".as_ref(), realm_governing_token_mint.key().as_ref()]
function registrarAddress({ programId, realm, mint, }) {
    return web3_js_1.PublicKey.findProgramAddressSync([realm.toBytes(), (0, utf8_1.encode)('registrar'), mint.toBytes()], programId);
}
exports.registrarAddress = registrarAddress;
// [registrar.key().as_ref(), b"voter-weight-record".as_ref(), voter_authority.key().as_ref()]
function voterWeightRecordAddress({ programId, registrar, voterAuthority, }) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        registrar.toBytes(),
        (0, utf8_1.encode)('voter-weight-record'),
        voterAuthority.toBytes(),
    ], programId);
}
exports.voterWeightRecordAddress = voterWeightRecordAddress;
// [registrar.key().as_ref(), b"voter".as_ref(), voter_authority.key().as_ref()]
function voterAddress({ programId, registrar, voterAuthority, }) {
    return web3_js_1.PublicKey.findProgramAddressSync([registrar.toBytes(), (0, utf8_1.encode)('voter'), voterAuthority.toBytes()], programId);
}
exports.voterAddress = voterAddress;
function vaultAddress({ voter, mint, }) {
    return (0, solana_spl_token_modern_1.getAssociatedTokenAddressSync)(mint, voter, true);
}
exports.vaultAddress = vaultAddress;
//# sourceMappingURL=VsrClient.js.map